import React, {createContext, useContext, useState} from "react";

const ClipActiveFiltersContext = createContext();

export const ClipActiveFiltersProvider = ({ children }) => {
    const [clipActiveFilters, setClipActiveFilters] = useState({});
    const [clipSearchOptions, setClipSearchOptions] = useState();

    function setClipSearchOption(fieldName, value){
        const tempSearchOptions = {...clipSearchOptions};
        tempSearchOptions[fieldName] = value
        setClipSearchOptions(tempSearchOptions);
    }

    const handleClipActiveFilter = (name, value, type = '') => {
        const tempActiveFilters = {...clipActiveFilters}
        tempActiveFilters[name] = value;
        tempActiveFilters.lastTypeModified = type;
        setClipActiveFilters(tempActiveFilters);
    }

    const resetClipActiveOption = () => {
        setClipActiveFilters({});
        setClipSearchOptions();
    }

    return (
        <ClipActiveFiltersContext.Provider value={{clipActiveFilters, setClipActiveFilters, handleClipActiveFilter, setClipSearchOption, clipSearchOptions, resetClipActiveOption}}>
            {children}
        </ClipActiveFiltersContext.Provider>
    );
};

export const useClipActiveFilters = () => {
    const context = useContext(ClipActiveFiltersContext);
    if (!context) {
        throw new Error("useActiveFilters deve essere usato dentro ActiveFiltersProvider");
    }
    return context;
};